import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { SpaceliftVcs } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import CopyFieldDropdownMenuItem from "components/CopyField/DropdownMenuItem";

const SpaceliftVcsReposTableRowActionsCell = ({
  item: repo,
  ...cellProps
}: TableSimpleCellProps<SpaceliftVcs>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <DropdownMenuEllipsis tooltip="Repo actions">
        <CopyFieldDropdownMenuItem title="Copy ID" value={repo.id} />
      </DropdownMenuEllipsis>
    </TableSimpleCell>
  );
};

export default SpaceliftVcsReposTableRowActionsCell;
